export const excludeFromList = (list, itemId) => list.filter(item => item !== itemId);
